export default __webpack_public_path__ + "static/media/cunningstrike2.4012d86f.png";